// extracted by mini-css-extract-plugin
module.exports = {"coupon_item":"CouponItem_coupon_item__VZbyN"};